export default __webpack_public_path__ + "media/images/cta_blocks/confirm_dates_venues-6b1135b31537746315bf0249b01267eb.jpg";